import { render, staticRenderFns } from "./MySpa.vue?vue&type=template&id=b4204008&scoped=true"
import script from "./MySpa.vue?vue&type=script&lang=js"
export * from "./MySpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4204008",
  null
  
)

export default component.exports